import { WindowObject, getWindowObject } from "@btcdirect/functions";
import { useDesktopAppWithApplePay } from "@btcdirect/shared/src/composables/util/client-types";
import { useLogger } from "@btcdirect/shared/src/composables/util/logger";
import { PaymentMethod, useClientInfoStore } from "@btcdirect/stores";
import { usePaymentMethodsStore } from "@btcdirect/stores/src/payment-methods";

/**
 * Enable or disable Apple Pay
 */
export function setApplePaySupport(paymentMethods: PaymentMethod[]): void {
    const paymentMethodsStore = usePaymentMethodsStore();
    const windowObject: WindowObject = getWindowObject();
    const { warn } = useLogger();

    const applePayIndex = paymentMethods.findIndex((method: PaymentMethod) => method.code === "applepay");

    function disable(reason?: string): void {
        if (paymentMethodsStore.selectedPaymentMethod && paymentMethodsStore.selectedPaymentMethod.code === "applepay") {
            // Unset the payment method so it is auto-selected by the store based on country
            paymentMethodsStore.selectPaymentMethod(null);
        }

        paymentMethods.splice(applePayIndex, 1);

        warn("Coulnd't initialize Apple Pay", reason || null);
    }

    const navigator = windowObject.navigator;
    const navigatorData = [navigator?.userAgent, navigator?.userAgentData?.platform, navigator?.platform, navigator?.appVersion];

    const isDesktopAppWithApplePay = useDesktopAppWithApplePay();

    const isAppleDevice = navigatorData.some((data) => data?.toLowerCase().includes("mac"));

    if (isDesktopAppWithApplePay && !isAppleDevice) {
        disable("No Apple device detected");
        return;
    }

    try {
        const canMakePayments = windowObject?.ApplePaySession?.canMakePayments?.();

        // Outside of desktop apps with Apple Pay, check device + Apple Pay support
        if (!isDesktopAppWithApplePay && !(isAppleDevice && canMakePayments)) {
            disable("No Apple device detected or Apple Pay not supported");
        }
    } catch (exception) {
        disable(exception.message);
    }
}
